import React from "react"
import { useRoutes } from "react-router-dom"

import SpinCustom from "src/components/SpinCustom"
import ROUTER from "./ROUTER"

// common
const PublicRouters = React.lazy(() =>
  import("src/pages/SUPPORTPAGES/PublicRouters"),
)
const SvgViewer = React.lazy(() => import("src/pages/SUPPORTPAGES/SvgViewer"))
const NotFound = React.lazy(() => import("src/pages/SUPPORTPAGES/NotFound"))
const Home = React.lazy(() => import("src/pages/ANONYMOUS/HomePage/Home"))
const ListFileSearch = React.lazy(() =>
  import("src/pages/ANONYMOUS/ListFileSearch"),
)
const PrivateRoutes = React.lazy(() =>
  import("src/pages/SUPPORTPAGES/PrivateRoutes"),
)
const AminRoutes = React.lazy(() => import("src/pages/SUPPORTPAGES/AminRoutes"))
// ANONYMOUS

const GuestRegister = React.lazy(() =>
  import("src/components/Login/src/Guest/GuestLogin"),
)

// USER

const ChangePassword = React.lazy(() => import("src/pages/USER/ChangePassword"))
const MyAccount = React.lazy(() => import("src/pages/USER/MyAccount"))
// ADMIN
const Role = React.lazy(() => import("src/pages/ADMIN/Role"))
const EmployeeContact = React.lazy(() =>
  import("src/pages/ADMIN/EmployeeContact"),
)
const ListForm = React.lazy(() => import("src/pages/ADMIN/ListForm"))
const ImportDispatch = React.lazy(() =>
  import("src/pages/ADMIN/ImportDispatch"),
)
const PositionManager = React.lazy(() =>
  import("src/pages/ADMIN/PositionManager"),
)

function LazyLoadingComponent({ children }) {
  return (
    <React.Suspense
      fallback={
        <div className="loading-center" style={{ height: "100vh" }}>
          <SpinCustom fullscreen />
        </div>
      }
    >
      {children}
    </React.Suspense>
  )
}
const routes = [
  {
    path: ROUTER.SVG_VIEWER,
    element: (
      <LazyLoadingComponent>
        <SvgViewer />
      </LazyLoadingComponent>
    ),
  },

  // ADMIN
  {
    element: (
      <LazyLoadingComponent>
        <AminRoutes />
      </LazyLoadingComponent>
    ),
    children: [
      {
        path: ROUTER.QUAN_LY_PHAN_QUYEN,
        element: (
          <LazyLoadingComponent>
            <Role />
          </LazyLoadingComponent>
        ),
      },
      {
        path: ROUTER.DANH_BA_NHAN_VIEN,
        element: (
          <LazyLoadingComponent>
            <EmployeeContact />
          </LazyLoadingComponent>
        ),
      },
      {
        path: ROUTER.DANH_SACH_CONG_VAN,
        element: (
          <LazyLoadingComponent>
            <ListForm />
          </LazyLoadingComponent>
        ),
      },
      {
        path: ROUTER.IMPORT_CONG_VAN,
        element: (
          <LazyLoadingComponent>
            <ImportDispatch />
          </LazyLoadingComponent>
        ),
      },
      {
        path: ROUTER.DANH_SACH_CHUC_VU,
        element: (
          <LazyLoadingComponent>
            <PositionManager />
          </LazyLoadingComponent>
        ),
      },
    ],
  },
  //  USER
  {
    element: (
      <LazyLoadingComponent>
        <PrivateRoutes />
      </LazyLoadingComponent>
    ),
    children: [
      {
        path: ROUTER.DOI_MAT_KHAU,
        element: (
          <LazyLoadingComponent>
            <ChangePassword />
          </LazyLoadingComponent>
        ),
      },
      {
        path: ROUTER.THONG_TIN_TAI_KHOAN,
        element: (
          <LazyLoadingComponent>
            <MyAccount />
          </LazyLoadingComponent>
        ),
      },
    ],
  },
  //  ANONYMOUS
  {
    element: (
      <LazyLoadingComponent>
        <PublicRouters />
      </LazyLoadingComponent>
    ),
    children: [
      {
        path: ROUTER.HOME,
        element: (
          <LazyLoadingComponent>
            <Home />
          </LazyLoadingComponent>
        ),
      },
      {
        path: ROUTER.TRA_CUU_DON,
        element: (
          <LazyLoadingComponent>
            <ListFileSearch />
          </LazyLoadingComponent>
        ),
      },
      {
        path: `${ROUTER.TRA_CUU_DON}/:id`,
        element: (
          <LazyLoadingComponent>
            <ListFileSearch />
          </LazyLoadingComponent>
        ),
      },

      {
        path: ROUTER.DANG_KY_THONG_TIN_KHACH,
        element: (
          <LazyLoadingComponent>
            <GuestRegister />
          </LazyLoadingComponent>
        ),
      },
    ],
  },
  {
    path: "*",
    element: (
      <LazyLoadingComponent>
        <NotFound />
      </LazyLoadingComponent>
    ),
  },
]
const AppRouter = () => {
  const renderRouter = useRoutes(routes)
  return renderRouter
}
export default AppRouter
